import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class NotificationCounterService {
  private readonly countSubject = new BehaviorSubject<number>(0);

  readonly count$ = this.countSubject.asObservable();

  get value(): number {
    return this.countSubject.value;
  }

  setValue(count: number): void {
    this.countSubject.next(Math.max(0, count));
  }

  increment(by = 1): void {
    this.setValue(this.value + by);
  }

  decrement(by = 1): void {
    this.setValue(this.value - by);
  }

  reset(): void {
    this.countSubject.next(0);
  }
}
